module.exports = "/assets/packs/images/576ac041c695cfeb1641b5dd435663fa.png";